export default "__VITE_ASSET__916cf05f__"